
import Answer from "./Answer";


export default function AnswerSection({ discussion, onReloadNeeded }) {
	return (
		<>
			{discussion.answers.map(answer => (
				<div key={answer.id}>
					<Answer answer={answer} onReloadNeeded={onReloadNeeded} />
					<div className="spacer p-[10px]"></div>
				</div>
			))}
		</>
	)
}
